import { Injectable } from '@angular/core';
import {
  Project,
  ProjectBuilder,
  ProjectMapperInterface,
} from '@web-portal/domains/shared/domain-models';
import { ApiConfig } from 'bimplus-websdk';

@Injectable()
export class ProjectMapper implements ProjectMapperInterface<Project> {
  mapToProject(projectData: unknown, apiConfig?: ApiConfig): Project {
    if (!ProjectMapper.isProject(projectData)) {
      console.error('[ProjectMapper]: Invalid project data:', projectData);
      return {} as unknown as Project;
    }

    const projectBuilder = new ProjectBuilder()
      .withId(projectData.id)
      .withName(projectData.name)
      .withTeamName(projectData.teamName)
      .withTeamSlug(projectData.teamSlug)
      .withRights(projectData.rights)
      .withModelsCount(projectData)
      .withTasksCount(projectData);

    if (apiConfig) {
      return projectBuilder.withThumbnailUrl(projectData, apiConfig).build();
    }

    return projectBuilder.build();
  }

  /**
   * Validates if the provided data conforms to the Project interface.
   * @param projectData
   * @returns boolean
   */
  static isProject(projectData: unknown): projectData is Required<Project> {
    return (
      typeof projectData === 'object' &&
      projectData !== null &&
      'teamSlug' in projectData &&
      'id' in projectData &&
      'teamName' in projectData &&
      'name' in projectData
    );
  }
}
